import React from "react";
import styles from "./style.module.scss";
import SecondBg from "Utils/Assets/Images/Vector.png";
import CoinsVideo from "../../../Utils/Assets/Images/coins-rotating.webm";
import { useNavigate } from "react-router";

const CoinTowHeader = () => {
    const navigate = useNavigate();

    return (
        <div className={styles.root}>
            <img
                src={SecondBg}
                alt="overlay"
                className={styles.HeaderOverlay}
            />

            <div className={styles.content}>
                <div className={styles.flex}>
                    <div className={styles.textContent}>
                        <button
                            name="LearnMoreButton"
                            aria-label="Platform Staking & Engagement"
                            className={styles.learnMoreBtn}
                        >
                            <p>Platform Staking & Engagement</p>
                        </button>
                        <h1>
                            Unlock the Power of MVR Influence Coin
                        </h1>
                        
                        <div className={styles.btnHolder}>
                            <button
                                name="Download&StartEarningButton"
                                aria-label="Download & Start Earning"
                                className={`${styles.button} ${styles.downloadBtn}`}
                                onClick={() => navigate("/download-app")}
                            >
                                <p>Get Your Coin Now</p>
                            </button>
                        </div>
                    </div>
                    <div className={styles.videoWrapper}>
                        <video
                            src={CoinsVideo}
                            autoPlay
                            loop
                            muted
                            playsInline
                            className={styles.coinsVideo}
                            data-aos="fade-up"
                            data-aos-duration="800"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CoinTowHeader;
